import script from "./ActionTwoButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionTwoButtons.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardActions,QBtn,QSpace});
